var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "img-auth" }, [
    _c("a", { attrs: { href: "javascript:void (0)" } }, [
      _c("img", {
        class: _vm.classSize,
        attrs: { src: "data:image/png;base64," + _vm.imgAuth.imgPath },
        on: { click: _vm.getImgAuth }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53a9ab78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53a9ab78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/img-auth/img-auth.vue
// module id = rdj9
// module chunks = 0 1 12 13 28 34 38 39 58 59 64 105 124 139 140 144 147